<template>
  <Card class="layout-card">
    <template v-if="editMovieVisible">
      <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;">
        <div style="display:flex;align-items:flex-start;">
          <a @click="handleCloseMovieEdit" style="margin-right:10px;color:#2d8cf0;margin-top:4px;">
            <Icon type="ios-arrow-back" style="font-size:18px;"></Icon>
          </a>
          <div>
            <div style="font-size:16px;font-weight:600;">{{ editMovieForm.searchPageName }} · 短剧列表</div>
            <div style="font-size:12px;color:#999;font-weight:normal;margin-top:6px;">
              <span>{{ editMovieForm.langName || editMovieForm.chineseLangName || '' }}</span>
              <span v-if="(editMovieForm.langName || editMovieForm.chineseLangName) && editMovieForm.searchPageStyle"> · </span>
              <span>搜索页</span>
              <span v-if="((editMovieForm.langName || editMovieForm.chineseLangName) || editMovieForm.searchPageStyle) && searchPageStyleName"> · </span>
              <span>{{ searchPageStyleName || '' }}</span>
            </div>
          </div>
        </div>
        <Button type="primary" @click="handleOpenAddMovie">添加短剧</Button>
      </div>
      <movieList ref="movieListRef" v-if="editMovieForm.id" :form="editMovieForm"></movieList>
    </template>
    <template v-else>
    <div
      style="
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="lang-tabs-wrapper">
        <div style="width:100%;overflow-x:auto;">
          <Tabs v-model="activeLangId" :animated="false" @on-click="handleTabLangChange" class="lang-tabs">
            <TabPane
                v-for="(item, index) in langList"
                :key="'tab-lang-'+(item.id || index)"
                :label="item.chineseLangName"
                :name="String(item.id)">
            </TabPane>
          </Tabs>
        </div>
      </div>
      <div class="search-bar-wrapper">
        <div style="display:flex;justify-content:space-between;align-items:center;">
        <div class="search-form">
          <Input
            :maxlength="100"
            v-model="searchForm.searchPageName"
            placeholder="请输入搜索页名称"
          />
          <Select
            style="width: 130px"
            v-model="searchForm.searchPageChannel"
            placeholder="请选择应用渠道"
            clearable
          >
            <Option :value="0">APP</Option>
            <Option :value="1">WEB</Option>
          </Select>
          <Select
            style="width: 130px"
            v-model="searchForm.searchPageStatus"
            placeholder="请选择状态"
            clearable
          >
            <Option :value="1">开启</Option>
            <Option :value="0">关闭</Option>
          </Select>
          <Button
            type="primary"
            @click="getData()"
            >查询</Button
          >
          <Button @click="handleReset()">重置</Button>
        </div>
        <div>
          <Button
            type="primary"
            @click="handleOpenEditModal()"
            >新增</Button
          >
        </div>
        </div>
      </div>
    </div>

    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #searchPageStatus="{ row }">
          <div>
            <i-switch
              :value="row.searchPageStatus"
              :before-change="() => handleChangeStatus(row)"
            ></i-switch>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              @click="handleOpenMovieList(row)"
              >编辑短剧列表</a
            >
            <a
              style="margin-left: 10px"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <Poptip
              confirm
              title="确定要删除吗？"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '搜索页'">
      <Form
        @submit.native.prevent
        v-if="editVisible"
        :label-width="120"
        :model="form"
        ref="formRef"
      >
        <FormItem
          label="搜索页名称："
          placeholder="请输入搜索页名称"
          prop="searchPageName"
          :rules="[{ required: true, message: '请输入搜索页名称' }]"
        >
          <Input :maxlength="100" v-model="form.searchPageName" />
        </FormItem>
        <FormItem
          label="排序值："
          prop="searchPageSort"
          placeholder="请输入排序值"
          :rules="[{ required: true, message: '请输入排序值' }]"
        >
          <InputNumber :min="0" v-model="form.searchPageSort" :max="99999" />
        </FormItem>
        <FormItem
          label="所属语言："
          prop="langId"
          :rules="[{ required: true, message: '请选择所属语言' }]"
        >
          <Select
            v-model="form.langId"
            placeholder="请选择语言"
          >
            <Option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.id"
              >{{ item.chineseLangName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="应用渠道："
          :rules="[{ required: true, message: '请选择应用渠道' }]"
          prop="searchPageChannel"
        >
          <Select v-model="form.searchPageChannel">
            <Option :value="0">APP</Option>
            <Option :value="1">WEB</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="form.searchPageChannel === 0"
          prop="searchPageStyle"
          :rules="[{ required: true, message: '请选择展示样式' }]"
        >
          <template #label> 展示样式： </template>
          <Select
            placeholder="请选择展示样式"
            v-model="form.searchPageStyle"
            disabled
          >
            <Option :value="13">搜索页样式</Option>
          </Select>
        </FormItem>
        <FormItem
          label="状态："
          prop="searchPageStatus"
          :rules="[{ required: true, message: '请选择状态' }]"
        >
          <i-switch v-model="form.searchPageStatus"></i-switch>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
    </template>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import style1 from '@/assets/images/style1.png'
import style2 from '@/assets/images/style2.png'
import style3 from '@/assets/images/style3.png'
import search from '@/components/searchMode'
import style4 from '@/assets/images/style4.png'
import style5 from '@/assets/images/style5.jpg'
import movieList from './components/movie-list.vue'
import {
  getSearchPageList,
  addSearchPage,
  delSearchPage,
  editSearchPage,
  getSearchPageInfo,
  changeSearchPageStatus
} from '@/api/search'
import { getLangList } from '../../api/lang'
export default {
  components: {
    Pages,
    search,
    movieList
  },
  data() {
    return {
      style1,
      style2,
      style3,
      style4,
      style5,
      editVisible: false,
      submitLoading: false,
      editMovieVisible: false,
      editMovieForm: {},
      form: {},
      langList: [],
      activeLangId: '',
      searchForm: {},
      page: {
        current: 1,
        size: 10,
      },
      tableData: [],
      columns: [
        {
          title: '搜索页名称',
          key: 'searchPageName'
        },
        {
          title: '排序值',
          key: 'searchPageSort'
        },
        {
          title: '所属语言',
          key: 'langName'
        },
        {
          title: '应用渠道',
          key: 'searchPageChannel',
          render: (h, { row }) => {
            return h('span', row.searchPageChannel === 0 ? 'APP' : row.searchPageChannel === 1 ? 'WEB' : '-')
          }
        },
        {
          title: '展示样式',
          render: (h, { row }) => {
            return h('span', row.searchPageStyle === 13 ? '搜索页样式' : '-')
          }
        },
        {
          title: '状态',
          slot: 'searchPageStatus'
        },
        {
          title: '操作',
          align: 'center',
          width: 200,
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/search')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    },
    searchPageStyleName() {
      const styleMap = {
        13: '搜索页样式'
      }
      const value = this.editMovieForm && this.editMovieForm.searchPageStyle
      if (value === undefined || value === null || value === '') return ''
      return styleMap[value] || ''
    }
  },
  methods: {
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      const langParam = this.activeLangId ? { langId: this.activeLangId } : {}
      getSearchPageList({
        ...this.page,
        ...this.searchForm,
        ...langParam
      }).then(({ data }) => {
        console.log(data)
        this.tableData = data.records || []
      })
    },
    handleTabLangChange() {
      this.getData()
    },
    handleChangeStatus(row) {
      changeSearchPageStatus(row.id)
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getSearchPageInfo(row.id)
        const data = { ...r.data }
        this.form = {
          ...data,
          searchPageStatus: !!data.searchPageStatus
        }
      } else {
        this.form = {
          searchPageSort: 0,
          searchPageStatus: false,
          searchPageChannel: 0,
          searchPageStyle: 13
        }
      }

      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          const func = this.form.id ? editSearchPage : addSearchPage
          this.submitLoading = true
          const submitData = { ...this.form }
          submitData.searchPageStyle = 13
          func(submitData)
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
              this.submitLoading = false
              this.editVisible = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    handleGetLang() {
      getLangList({
        current: -1,
        size: -1
      }).then((r) => {
        const list = r.data.records || []
        const isChineseName = (name) => /中文|汉语|普通话/.test(name || '')
        const nonChinese = list.filter(i => !isChineseName(i.chineseLangName))
        const chinese = list.filter(i => isChineseName(i.chineseLangName))
        this.langList = [...nonChinese, ...chinese]
        if (this.langList.length > 0) {
          const englishFirst = nonChinese.find(i => /英语|英文|English/i.test(i.chineseLangName || i.langName || ''))
          const defaultItem = englishFirst || nonChinese[0] || this.langList[0]
          this.activeLangId = String(defaultItem.id)
          this.getData()
        }
      })
    },
    handleOpenMovieList(row) {
      this.editMovieForm = { ...row }
      this.editMovieVisible = true
    },
    handleCloseMovieEdit() {
      const needConfirm = this.$refs.movieListRef && this.$refs.movieListRef.hasUnsavedChanges
      const doClose = () => {
        this.editMovieVisible = false
        this.editMovieForm = {}
        this.getData()
      }
      if (needConfirm) {
        this.$Modal.confirm({
          title: '更改尚未保存',
          content: '离开后，本次对短剧列表的调整将不会保存。确定要返回搜索页列表吗？',
          okText: '放弃更改并返回',
          cancelText: '继续编辑',
          type: 'warning',
          closable: true,
          onOk: doClose
        })
      } else {
        doClose()
      }
    },
    handleOpenAddMovie() {
      if (this.$refs.movieListRef) {
        this.$refs.movieListRef.handleOpen()
      }
    },
    handleDel(row) {
      delSearchPage(row.id).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
      if (this.langList.length > 0) {
        const nonChinese = this.langList.filter(i => !/中文|汉语|普通话/.test(i.chineseLangName))
        const englishFirst = nonChinese.find(i => /英语|英文|English/i.test(i.chineseLangName || i.langName || ''))
        const defaultItem = englishFirst || nonChinese[0] || this.langList[0]
        this.activeLangId = String(defaultItem.id)
      }
      this.getData()
    },
  },
  mounted() {
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  & > * {
    margin: 0 5px;
  }
}

.style-img {
  width: 350px;
}

.layout-card {
  min-height: calc(100vh - 120px);
  /deep/ .ivu-card-body {
    min-height: calc(100vh - 180px);
  }
}

.lang-tabs-wrapper {
  padding: 0 16px;
  background: #fff;
  margin-bottom: 12px;

  /deep/ .lang-tabs {
    min-width: max-content;
    border: none;

    .ivu-tabs-nav {
      height: 44px;
      border: none;
      margin-bottom: 0;
    }

    .ivu-tabs-nav-scroll {
      padding-right: 0;
    }

    .ivu-tabs-tab {
      margin-right: 28px;
      padding: 12px 0;
      font-size: 14px;
      border: none;
      background: transparent;
      line-height: 20px;
      position: relative;

      &:hover {
        color: #2d8cf0;
      }
    }

    .ivu-tabs-tab-active {
      color: #2d8cf0;
      font-weight: 500;
      border: none;
      background: transparent;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #2d8cf0;
      }
    }

    .ivu-tabs-ink-bar {
      display: none;
    }
  }
}

.search-bar-wrapper {
  padding: 0 0 10px 0;
}

.rank-type-radio-group {
  /deep/ .ivu-radio-wrapper {
    display: inline-flex;
    align-items: center;
    margin-right: 16px;
    padding: 0 18px 0 12px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background: #fff;
    transition: all 0.2s;

    &:hover {
      border-color: #57a3f3;
    }

    .ivu-radio {
      margin-right: 8px;
    }

    &.ivu-radio-wrapper-checked {
      background: #1890ff;
      border-color: #1890ff;
      color: #fff;

      .ivu-radio-inner {
        border-color: #fff;
        background-color: #1890ff;

        &::after {
          background-color: #fff;
        }
      }
    }
  }
}
</style>

<style lang="less">
.rank-rule-poptip {
  max-width: 400px;

  .popper-inner {
    overflow-x: hidden !important;
    overflow-y: auto;
    padding: 14px !important;
  }

  .rank-rule-content {
    width: 340px;
    color: #333;
    font-size: 13px;
    word-wrap: break-word;
    word-break: break-word;

    .rule-title {
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .rule-desc {
      margin-bottom: 8px;
      line-height: 1.6;
    }

    .rule-list {
      margin: 0 0 12px 0;
      padding-left: 18px;

      li {
        margin-bottom: 5px;
        line-height: 1.6;
        white-space: normal;
        word-wrap: break-word;
      }
    }

    .rule-app-title {
      font-weight: 600;
      margin-bottom: 8px;
    }

    .rule-img {
      max-width: 260px;
      width: 260px;
      display: block;
      margin: 0 auto;
      border: 1px solid #ececec;
      border-radius: 4px;
    }
  }
}
</style>